module.exports = __webpack_public_path__ + "img/completion1.71a9f297.svg";